import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuelidate from "vuelidate";
import loadingProgress from "@/components/loadingProgress";
import VueTour from "vue-tour";
import VueYoutube from "vue-youtube";
import VueGtag from "vue-gtag";
import JsonCSV from "vue-json-csv";
import * as GmapVue from "gmap-vue";
Vue.config.productionTip = false;
import "./registerServiceWorker";

const appVersion = localStorage.getItem("appVersion");

if (appVersion !== 'public') {
  localStorage.clear();
  localStorage.setItem("appVersion", "public");

  window.location.href = '/welcome'
}

/* require("vue-tour/dist/vue-tour.css"); */
const clickOutside = () => {
  Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
      el.clickOutsideEvent = function (event) {
        if (!(el == event.target || el.contains(event.target))) {
          vnode.context[binding.expression](event)
        }
      };
      document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
      document.body.removeEventListener('click', el.clickOutsideEvent)
    },
  });
}
Vue.use(clickOutside)
Vue.component("loadingProgress", loadingProgress);
Vue.component("downloadCsv", JsonCSV);
Vue.use(VueYoutube);
Vue.use(VueTour);
Vue.use(GmapVue, {
  load: {
    key: "AIzaSyDcgNeXeDFU--_-7pywjEO5xOilsLnR9-w",
    libraries: "places",
  },
}),
  Vue.use(
    VueGtag,
    {
      config: { id: "G-PG7WSNXKWD" },
      appName: "ActToAdapt",
      pageTrackerScreenviewEnabled: true,
    },
    router
  );
Vue.config.productionTip = false;
let tTipped = () => {
  Vue.directive("tipped", {
    bind: function (el) {
      /* if (!el.attributes["data-tooltip"]) return; */
      setTimeout(() => {
        const options = {};
        M.Tooltip.init(el, options);
      }, 300);
    },
    unbind: function (el) {
      /* if (!el.attributes["data-tooltip"]) return; */
      setTimeout(() => {
        let instance = M.Tooltip.getInstance(el);
        instance.destroy();
      }, 300);
    },
  });
};
Vue.use(tTipped);

Vue.use(Vuelidate);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// router.onReady(() => {
//   app;
// });
